import { t } from '@lingui/core/macro'
import { useMemo, useState } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import ECharts from '~/components/echarts'
import Filters from '~/dashboard/azure_virtual_machines_dashboard_filters'
import {
  azureQuantityByVirtualMachineVmSizeChartPath,
  azureVmMonthlyCostsByInstanceSeriesQueryChartPath,
  azureVmMonthlyCostsByPricingModelQueryChartPath,
  azureVmQuantityByPowerStateQueryChartPath,
} from '~/routes'

export default function AzureVirtualMachinesDashboardCharts({ organizationId: orgId }) {
  const [inventoryChartParams, setInventoryChartParams] = useState({})
  const [mainChartParams, setMainChartParams] = useState({ azureCostKind: 'ActualCost' })

  const [openedTabs, setOpenedTabs] = useState(['main-tab'])
  const [activeTab, setActiveTab] = useState('main-tab')

  const handleTabChange = (tabName) => {
    setActiveTab(tabName)

    // Lazy load charts
    if (!openedTabs.includes(tabName)) {
      setOpenedTabs((prevOpenedTabs) => [...prevOpenedTabs, tabName])
    }
  }

  const openedTab = (tabName) => {
    return openedTabs.includes(tabName)
  }

  const monthlyCostsByPricingModelUrl = useMemo(() => azureVmMonthlyCostsByPricingModelQueryChartPath(orgId), [orgId])
  const monthlyCostsByInstanceSeriesUrl = useMemo(
    () => azureVmMonthlyCostsByInstanceSeriesQueryChartPath(orgId),
    [orgId],
  )
  const quantityByPowerStateUrl = useMemo(() => azureVmQuantityByPowerStateQueryChartPath(orgId), [orgId])
  const quantityByVmSizeUrl = useMemo(() => azureQuantityByVirtualMachineVmSizeChartPath(orgId), [orgId])

  return (
    <div className='card-tabs'>
      <Tabs id='controlled-tabs' activeKey={activeTab} onSelect={(k) => handleTabChange(k)}>
        <Tab eventKey='main-tab' title={t`Main Spend`}>
          <div className='tab-content'>
            <div className='card tab-pane active show'>
              <div className='card-body'>
                <Filters organizationId={orgId} setChartParams={setMainChartParams} />
                {openedTab('main-tab') && (
                  <div className='row gy-4'>
                    <div className='col-sm-6'>
                      <ECharts
                        title={t`Costs By Pricing Model`}
                        chartInfoTitle='azure_costs_by_pricing_model'
                        url={monthlyCostsByPricingModelUrl}
                        params={mainChartParams}
                        showExportButton
                      />
                    </div>
                    <div className='col-sm-6'>
                      <ECharts
                        title={t`Costs By Instance Series`}
                        chartInfoTitle='azure_costs_by_instance_series'
                        url={monthlyCostsByInstanceSeriesUrl}
                        params={mainChartParams}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Tab>

        <Tab eventKey='inventory-tab' title={t`Inventory`}>
          <div className='tab-content'>
            <div className='card tab-pane active show'>
              <div className='card-body'>
                <Filters organizationId={orgId} setChartParams={setInventoryChartParams} />
                {openedTab('inventory-tab') && (
                  <div className='row gy-4'>
                    <div className='col-sm-6'>
                      <ECharts
                        title={t`Quantity By Power State`}
                        chartInfoTitle='azure_quantity_by_power_state'
                        url={quantityByPowerStateUrl}
                        params={inventoryChartParams}
                      />
                    </div>
                    <div className='col-sm-6'>
                      <ECharts
                        title={t`Quantity By VM Size`}
                        chartInfoTitle='azure_quantity_by_vm_size'
                        url={quantityByVmSizeUrl}
                        params={inventoryChartParams}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  )
}
